export default ['ur', 'ir', 'ar']